/**
 * Date/Time formatting utilities.
 * Replaces 5 duplicate formatRelativeTime/formatDate functions across the codebase.
 */

/**
 * Formats a date string as relative time (e.g. "2h ago", "3d", "just now").
 * @param dateStr - ISO date string or null
 * @param suffix - Optional suffix appended after the relative time (e.g. ' ago' for i18n)
 */
export function formatRelativeTime(dateStr: string | null, suffix: string = ''): string {
  if (!dateStr) return '—';
  const date = new Date(dateStr);
  const now = Date.now();
  const diffMs = now - date.getTime();
  const absDiff = Math.abs(diffMs);
  const isFuture = diffMs < 0;

  const seconds = Math.floor(absDiff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  let label: string;
  if (seconds < 60) label = `${seconds}s`;
  else if (minutes < 60) label = `${minutes}m`;
  else if (hours < 24) label = `${hours}h`;
  else label = `${days}d`;

  if (suffix) {
    return label + suffix;
  }
  return isFuture ? `in ${label}` : `${label} ago`;
}

/**
 * Formats a date string/timestamp to locale date string.
 */
export function formatDate(dateStr: string | number): string {
  if (!dateStr) return '—';
  const date = new Date(dateStr);
  return date.toLocaleDateString();
}

/**
 * Formats a date string/timestamp to locale date + time string.
 */
export function formatDateTime(dateStr: string | number): string {
  if (!dateStr) return '—';
  const date = new Date(dateStr);
  return date.toLocaleString();
}
